import { ExecutableAction, ExecutableActionParam } from '../utils/executable-action';
import { KeyIdentifier, MessageCenterStateModel } from './message-center.model';

export class RemoveSingleMessage implements ExecutableAction<MessageCenterStateModel> {
  static readonly type = '[Message Center] Remove Single Message';

  static Warning(keyIdentifier: any) {
    return new RemoveSingleMessage(keyIdentifier);
  }

  constructor(private keyIdentifier: KeyIdentifier) {}

  execute(params: ExecutableActionParam<MessageCenterStateModel>): void {
    const state = params.ctx.getState();
    const nextState = state.filter(message => message.identifier !== this.keyIdentifier);
    params.ctx.setState(nextState);
  }
}
